import styled, { css } from 'styled-components';

const Button = styled.button`
  display: ${(props) => props.visible};
  all: unset;
  box-sizing: border-box;
  font-size: 1.6rem;
  padding: 0.75em 1em;
  background-color: var(--color-dirt_brown);
  border-radius: 5px;
  text-align: center;
  color: var(--color-white);
  border: 1.5px solid var(--color-dirt_brown);
  width: 100%;
  min-width: fit-content;
  max-width: 100%;
  transition: 0.15s;
  // box-shadow:  33px 33px 66px #9f9f9f, -10px -10px 33px #ffffff;
  box-shadow: ${(props) => props.boxShadow ? props.boxShadow : "rgb(229 229 229) 1px 1px 11px, rgb(255, 255, 255) -1px -1px 17px"};

  &:hover {
    cursor: pointer;
    background-color: var(--color-dirt_brown_dark);
  }

  &:focus {
    outline: none;
  }
  &:active {
    outline: none;
    transform: scale(0.95) !important;
  }

  &:disabled {
    color: var(--color-light_blue_grey);
    background-color: var(--color-pale_grey);
    border: 1.5px solid var(--color-pale_grey);
    cursor: not-allowed;
    box-shadow: none;
    ${(props) =>
      props.bordered &&
      css`
        color: var(--color-light_blue_grey);
        background-color: var(--color-white);
        border: 1.5px solid var(--color-light_blue_grey);
        &:hover {
          background-color: var(--color-white);
        }
      `};
  }

  ${(props) =>
    props.bordered &&
    css`
      color: var(--color-tan_two);
      background-color: var(--color-white);
      border: 1.5px solid var(--color-tan_two);
      box-shadow: none;
      &:hover {
        background-color: var(--color-white);
      }
    `};

  ${(props) =>
    props.mobile &&
    css`
      font-size: 1.2rem;
      padding: 0.75em 1em;
    `};
`;

export default Button;
